import { EventState } from "../../enums/event/event-states.enum";
import { EventType } from "../../enums/event/event-types.enum";
import { Currency } from "../../enums/price/currencies.enum";
import { IAutomatRule } from "../automat-rule/automat-rule.model";
import { IBrandProfile } from "../brand-profile/brand-profile.model";
import { IOrganization } from "../organization/organization.model";
import { IPrice } from "../price/price.model";
import { IShopItem } from "../shop-item/shop-item.model";
import { ICoordinator } from "../user/coordinator/coordinator.model";
import { IEventCustomSettings } from "./event-custom-settings.model";


export interface IEvent {
  id: number;
  uuid: string;
  uiIndex: number;
  title: string;
  code: string | null;
  subtitle: string | null;
  shortDescription: string | null;
  description: string | null;
  urlId: string;
  currencies: Currency[];
  state: EventState;
  type: EventType;
  format: EventFormat;
  reservationConfirmEmailTemplate: {
    replyTo: string;
    subject: string;
    template: string;
  } | null;
  internalTags: string[];
  customSettings: IEventCustomSettings;
  automatRules: IAutomatRule[];

  organizationId: number;
  organization?: IOrganization;
  coordinatorId: number | null;
  coordinator?: ICoordinator;
  shopItems: IShopItem[];
  brandProfileId: number | null;
  brandProfile?: IBrandProfile | null;

  archived: boolean;
  archivedAt: string | null;
  createdAt: string;
  updatedAt: string;
};

export interface IEventStatistics {
  reservationsCount: number;
  payingCustomersCount: number;
  eventIncome: IPrice[];
  customerValue: IPrice[];
};

export enum EventFormat {
  SEMESTER = 'SEMESTER',
  CONFERENCE = 'CONFERENCE',
  CAMP = 'CAMP',
  FESTIVAL = 'FESTIVAL',
  OFFER = 'OFFER',
  EVENT = 'EVENT',
}